import { render, staticRenderFns } from "./OnboardingStep3.vue?vue&type=template&id=50afd33c"
import script from "./OnboardingStep3.vue?vue&type=script&lang=js"
export * from "./OnboardingStep3.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep3.vue?vue&type=style&index=0&id=50afd33c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
